export const KeyCodes = { fo: 32, oo: 9, co: 13, mh: 27 };
